import React, { createContext, PropsWithChildren, ReactElement, useContext, useMemo, useState } from 'react';

export interface StickyTabInnerContextValue {
  /** 현재 활성화된 탭 id */
  activeTab?: string;
  /** 활성화된 탭을 변경합니다.
   * @param id 탭 id
   */
  onChangeActiveTab: (id: string) => void;
}

const initialValue: StickyTabInnerContextValue = {
  onChangeActiveTab: () => { /* noop */ },
};

const StickyTabInnerContext = createContext<StickyTabInnerContextValue>(initialValue);
export const useStickyTabInnerContext = (): StickyTabInnerContextValue => useContext(StickyTabInnerContext);

export function StickyTabInnerContextProvider({
  children,
  value = initialValue,
}: PropsWithChildren<{ value?: StickyTabInnerContextValue }>): ReactElement {
  const [activeTab, setActiveTab] = useState(value.activeTab);

  const contextValue: StickyTabInnerContextValue = useMemo(() => ({
    activeTab,
    onChangeActiveTab: (id: string) => setActiveTab(id),
  }), [activeTab]);

  return (
    <StickyTabInnerContext.Provider value={contextValue}>
      { children }
    </StickyTabInnerContext.Provider>
  );
}
